module.exports = __webpack_public_path__ + "static/assets/e97cbeda206c8637879f8db5477d494f.png";